import { createFileRoute } from '@tanstack/react-router';
import DocsGroupLayout from '@/components/Docs/DocsGroupLayout';

export const Route = createFileRoute('/about-legal')({
  component: AboutLegalLayout,
});

function AboutLegalLayout() {
  return <DocsGroupLayout group="about-legal" />;
}
